import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Paper, List, ListItemButton, ListItemText } from "@mui/material";
import "../styles/serachbar.css";
import menuData from "../JSON/db.json";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";

const extractMenuItems = (data: any) => {
  let items: { name: string; route: string }[] = [];

  Object.values(data).forEach((menuList: any) => {
    menuList.forEach((menuItem: any) => {
      if (menuItem.sub_options) {
        menuItem.sub_options.forEach((sub: any) => {
          items.push({
            name: `${menuItem.name} - ${sub.name}`,
            route: `/${menuItem.route.toLowerCase()}-${sub.name.toLowerCase()}`,
          });
        });
      }
    });
  });

  return items;
};

const SearchBar: React.FC = () => {
  const [query, setQuery] = useState("");
  const [menuItems, setMenuItems] = useState<{ name: string; route: string }[]>(
    []
  );
  const [filteredItems, setFilteredItems] = useState<
    { name: string; route: string }[]
  >([]);
  const [activeIndex, setActiveIndex] = useState(-1);
  const navigate = useNavigate();
  useEffect(() => {
    setMenuItems(extractMenuItems(menuData));
  }, []);

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.toLowerCase();
    setQuery(value);
    setFilteredItems(
      menuItems.filter((item) => item.name.toLowerCase().includes(value))
    );
    setActiveIndex(-1);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "ArrowDown") {
      setActiveIndex((prev) =>
        prev < filteredItems.length - 1 ? prev + 1 : prev
      );
    } else if (e.key === "ArrowUp") {
      setActiveIndex((prev) => (prev > 0 ? prev - 1 : prev));
    } else if (e.key === "Enter" && activeIndex >= 0) {
      navigate(filteredItems[activeIndex].route);
      setQuery("");
    }
  };

  const handleClick = (route: string) => {
    navigate(route);
    setQuery("");
  };

  return (
    <div>
      <div className="input-group search-box">
        <input
          type="text"
          className="form-control"
          onKeyDown={handleKeyDown}
          placeholder="Search here..."
          value={query}
          onChange={handleSearch}
        />
        <span className="input-group-text">
          <FontAwesomeIcon icon={faSearch} className="text-primary" />
        </span>
      </div>

      {query && filteredItems.length > 0 && (
        <Paper className="search-dropdown">
          <List>
            {filteredItems.map((item, index) => (
              <ListItemButton
                key={item.route}
                selected={activeIndex === index}
                onClick={() => handleClick(item.route)}
                className="search-dropdown-item"
              >
                <ListItemText primary={item.name} />
              </ListItemButton>
            ))}
          </List>
        </Paper>
      )}
    </div>
  );
};

export default SearchBar;
